import { customAxios } from './customAxios'

export function exportExcelADV() {

  const config = {
    headers: {
      Accept: "*/*",
      AuthToken: JSON.parse(localStorage.getItem('token'))
    }
  }

  return customAxios.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${process.env.REACT_APP_PATH_NEW_PREFIX}/report/excel`,
    {},
    config
  )
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error("Errore nell'export excel:", error);
      throw error;
    });
}